<template>
  <div>
    <div class="b-calendar__calendar">
      <div class="border-container" ref="content">
        <div class="border-bottom paddingContainer">
          <span class="month">Patient Name: 
              <span>
                  {{ selectedPatient.user.first_name | capitalizefirst }}
                  {{ selectedPatient.user.last_name | capitalizefirst }}
                </span>
          </span>
        </div>

        <div class="border-bottom paddingContainer">
          <span class="month">{{this.getQuarterRange}}</span>
        </div>

        <div class="b-calendar__dates">
          <div
            class="date text-right"
            :class="{
                                'today': date.today,
                                'blank': date.blank,
                                'no-border-right': date.key % 7 === 0,
                             }"
            v-for="date in dateList"
            :key="date.key"
          >
            <span class="day">{{date.dayNumber}}</span>
            <div class="additional">
              <span
                class="year"
                :class="{'year-selected':date.iscareplantaken === '50%'}"
              >{{date.iscareplantaken}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
        <v-loader :isLoading="isLoading" />
  </div>
</template>

<script>
import moment from "moment";
import VLoader from "@/components/loader/index.vue";
import { mapGetters } from "vuex";

export default {
  name: "weeklyReport",
  components:{
    VLoader
  },
  props: {
    selectedPatient: {
      type: Object
    },
    quarter: {
      type: Number,
      default: 1
    },selection: {
      type: String,
      default: "firstQuarter"
    }
  },
  data(){
      return {
       quartername: this.getQuarterRange
    };
  },
  mounted() {
    this.fetchPatientReports();
  },
  computed: {
     ...mapGetters({
      reports: "reports/getWeeklyReports",
      isLoading: "reports/getIsWeeklyReportLoading"
    }),
    getQuarterRange: function() {
      let $this = this;

      const start = moment()
        .quarter($this.quarter)
        .startOf("quarter")
        .format("MMM YYYY");

      const end = moment()
        .quarter($this.quarter)
        .endOf("quarter")
        .format("MMM YYYY");

      return "Quarter : " + start + " - " + end;
    },
    dateList: function() {
      let $this = this;

      let dateList = [];

      for (var i = 0; i < $this.reports.length; i++) {

        var progress = 0;

        if($this.reports[i].intervention_progress == 0||$this.reports[i].total_intervention == 0){
             progress = 0;
        }else{
         progress = (($this.reports[i].intervention_progress/$this.reports[i].total_intervention)*100)
         if(isNaN(progress)){
          progress = 0;
         }
      }

        
        dateList[i] = {
          key: i,
          dayNumber: "Week " + $this.reports[i].week,
          iscareplantaken: progress+ "%",
          blank: false,
          today: false
        };
      }

      return dateList.filter(function() {
        return true;
      });
    }
  },
  methods: {
     fetchPatientReports() {

        const start = moment()
        .quarter(this.quarter)
        .startOf("quarter")
        .format('YYYY-MM-DD');

      const end = moment()
        .quarter(this.quarter)
        .endOf("quarter")
        .format('YYYY-MM-DD');
     
     this.$store.dispatch(
        "reports/getPatientWeeklyReportById",
         {id:this.selectedPatient.id,selection:this.selection,startdate:start,enddate:end},
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../calendar.scss";
</style>